import {Injectable, Inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {DraftJobChanges} from '../../models/draft-job-changes.model';
import {DraftJobChangesFilter} from '../../models/draft-job-changes-filter.model';
import {DraftJobChangesPageParams} from './planning-draft-job-changes-http.service';
import {PlanningDraftJobChangesApiActions} from '../state/planning-draft-job-changes.actions';
import {planningDraftJobChangesFeature} from '../state/planning-draft-job-changes.state';

@Injectable()
export class PlanningDraftJobChangesFacadeService {

  constructor(@Inject(Store) private store: Store) {
  }

  // Selectors
  selectAll(): Observable<DraftJobChanges[]> {
    return this.store.select(planningDraftJobChangesFeature.selectAll);
  }

  selectTotalElements(): Observable<number> {
    return this.store.select(planningDraftJobChangesFeature.selectTotalElements);
  }

  selectPage(): Observable<number> {
    return this.store.select(planningDraftJobChangesFeature.selectPage);
  }

  selectSelectedIds(): Observable<string[]> {
    return this.store.select(planningDraftJobChangesFeature.selectSelectedIds);
  }

  selectSelectAllMatching(): Observable<boolean> {
    return this.store.select(planningDraftJobChangesFeature.selectSelectAllMatching);
  }

  selectSelectableIds(): Observable<string[]> {
    return this.store.select(planningDraftJobChangesFeature.selectSelectableIds);
  }

  selectFilters(): Observable<DraftJobChangesFilter> {
    return this.store.select(planningDraftJobChangesFeature.selectFilters);
  }

  selectLoading(): Observable<boolean> {
    return this.store.select(planningDraftJobChangesFeature.selectLoading);
  }

  selectScanning(): Observable<boolean> {
    return this.store.select(planningDraftJobChangesFeature.selectScanning);
  }

  selectApplying(): Observable<boolean> {
    return this.store.select(planningDraftJobChangesFeature.selectApplying);
  }

  // Actions
  scan(projectId: string, draftId: string): void {
    this.store.dispatch(PlanningDraftJobChangesApiActions.scanDraftJobChanges({projectId, draftId}));
  }

  getPage(projectId: string, draftId: string, params: DraftJobChangesPageParams): void {
    this.store.dispatch(PlanningDraftJobChangesApiActions.getDraftJobChangesPage({projectId, draftId, params}));
  }

  apply(projectId: string, draftId: string, filter: DraftJobChangesFilter): void {
    this.store.dispatch(PlanningDraftJobChangesApiActions.applyDraftJobChanges({projectId, draftId, filter}));
  }

  dismiss(projectId: string, draftId: string, filter: DraftJobChangesFilter): void {
    this.store.dispatch(PlanningDraftJobChangesApiActions.dismissDraftJobChanges({projectId, draftId, filter}));
  }

  getProcessTracking(projectId: string, draftId: string, params?: any): void {
    this.store.dispatch(PlanningDraftJobChangesApiActions.getDraftJobChangesProcessTracking({projectId, draftId, params}));
  }

  setSelectedIds(selectedIds: string[]): void {
    this.store.dispatch(PlanningDraftJobChangesApiActions.setSelectedIds({selectedIds}));
  }

  setSelectAllMatching(selectAllMatching: boolean): void {
    this.store.dispatch(PlanningDraftJobChangesApiActions.setSelectAllMatching({selectAllMatching}));
  }

  setFilters(filters: DraftJobChangesFilter): void {
    this.store.dispatch(PlanningDraftJobChangesApiActions.setFilters({filters}));
  }

  clearStore(): void {
    this.store.dispatch(PlanningDraftJobChangesApiActions.clearStore({force: true}));
  }
}
